import { render } from "./DomiciliationFormView.vue?vue&type=template&id=3ec2cc74"
import script from "./DomiciliationFormView.vue?vue&type=script&lang=js"
export * from "./DomiciliationFormView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/declic-center-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__